import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar, MatPaginator, MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { Plano } from '../../shared/models/plano.model';
import { WebIntegrPerfilADO } from '../../shared/models/webIntegrPerfilADO.model';
import { WebIntegrFuncionalidadeADO } from '../../shared/models/webIntegrFuncionalidadeADO.model';
import { PlanoService } from '../../shared/services/plano.service';
import { WebIntegrPerfilADOService } from '../../shared/services/webIntegrPerfilADO.service';
import { WebIntegrFuncionalidadeADOService } from '../../shared/services/webIntegrFuncionalidadeADO.service';
import { WebIntegrPerfilFuncADOService } from '../../shared/services/webIntegrPerfilFuncADO.service';
import { WebIntegrPerfilFuncADO } from '../../shared/models/webIntegrPerfilFuncADO.model';
import { InsertDialogFuncionalidadeComponent } from './dialogs/insert/insert.dialog.component';
import { DeleteDialogFuncionalidadeComponent} from './dialogs/delete/delete.dialog.component';

export interface PeriodicElement {
    categoria: string;
    plano: number;
    funcionalidade: string;
  }
  const ELEMENT_DATA: PeriodicElement[] = [
    {categoria: 'Teste', plano: 1234455555, funcionalidade: 'gdyegd'},
    {categoria: 'Teste', plano: 1234455555, funcionalidade: 'werbde dherrtt'},
    {categoria: 'Teste', plano: 1234455555, funcionalidade: 'werrdedertt'}
  
    ];
@Component({
  selector: 'app-config-funcionalidade',
  templateUrl: './config-funcionalidade.component.html',
  styleUrls: ['./config-funcionalidade.component.scss']
})



export class ConfigFuncionalidadeComponent implements OnInit {

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    
    displayedColumns: string[] = ['categoria', 'plano', 'funcionalidade', 'acoes'];
    dataSource = new MatTableDataSource<any>();

    listaPlano: Plano[] = [];
    listaPerfil: WebIntegrPerfilADO[] = [];
    listaFuncionalidade: WebIntegrFuncionalidadeADO[] = [];

    selectedPerfil: number;
    selectedPlano: number;
    selectedFuncionalidade: number;

    loading = false;

  constructor(
    public dialog: MatDialog,
    private planoService: PlanoService,
    private webIntegrPerfilADOService: WebIntegrPerfilADOService,
    private webIntegrFuncionalidadeADOService: WebIntegrFuncionalidadeADOService,
    private webIntegrPerfilFuncADOService: WebIntegrPerfilFuncADOService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.planoService.getAll().subscribe(obj => this.listaPlano = obj);
    this.webIntegrPerfilADOService.getAll().subscribe(obj => this.listaPerfil = obj);
    this.webIntegrFuncionalidadeADOService.getAll().subscribe(obj => this.listaFuncionalidade = obj);
  }
  buscar() {
    this.loading = true;
    console.log('teste')
    this.webIntegrPerfilFuncADOService.RetornarPor(this.selectedPerfil, this.selectedPlano, this.selectedFuncionalidade).subscribe(obj => {
      
      this.dataSource = new MatTableDataSource<WebIntegrPerfilFuncADO>(obj);
      this.dataSource.paginator = this.paginator;
      this.refreshTable();
  
        this.loading = false;
    });

  }
  private refreshTable() {
    this.paginator._changePageSize(this.paginator.pageSize);
  }
  limpar() {
    this.selectedPerfil = undefined;
    this.selectedPlano = undefined;
    this.selectedFuncionalidade = undefined;
  }

  insertNew() {
    const dialogRef = this.dialog.open(InsertDialogFuncionalidadeComponent, {
        width:'70%',
        
      data: { WebIntegrPerfilFuncADO: WebIntegrPerfilFuncADO }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {

        this.loading = true;
        this.webIntegrPerfilFuncADOService.Inserir(this.webIntegrPerfilFuncADOService.getDialogData()).subscribe(listInsert => {
          this.webIntegrPerfilFuncADOService.RetornarTodos().subscribe(obj => {
            this.dataSource = new MatTableDataSource<WebIntegrPerfilFuncADO>(obj);
            this.dataSource.paginator = this.paginator;
            this.refreshTable();
            this._snackBar.open('Funcionalidade liberada com sucesso', 'X', {
                duration: 30000,
                panelClass: ['red-snackbar']
            })
          });

          this.loading = false;
        });

      }
    });
  }
  deleteItem(data: WebIntegrPerfilFuncADO) {
    const dialogRef = this.dialog.open(DeleteDialogFuncionalidadeComponent, {
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.webIntegrPerfilFuncADOService.Deletar(data.iD_PERFIL, data.iD_FUNCIONALIDADE, data.iD_PLANO).subscribe(listDelete => {
          console.log(listDelete);
          this.webIntegrPerfilFuncADOService.RetornarTodos().subscribe(obj => {
            this.dataSource = new MatTableDataSource<WebIntegrPerfilFuncADO>(obj);
            this.dataSource.paginator = this.paginator;
            this.refreshTable();
            this._snackBar.open('Excluido com sucesso', 'X', {
                duration: 30000,
                panelClass: ['red-snackbar']
            })
          });

        });

      }
    });
  }
}
